import React, { useEffect, useState } from 'react';
import { Icon } from 'ui';

import { Text, TEXT_VARIANTS } from 'ui/Typography';
import request from 'utils/request_ajax';
import CopyLink from 'components/shared/CopyLink';

const HighFiveShareableLink = props => {
  const {
    hasAnswerBeenSubmitted = false,
    questionId,
    progressId,
    isGradable = true,
  } = props;
  const [shareableLink, setShareableLink] = useState('');

  const url = `/progresses/${progressId}/questions/${questionId}/answers/shareable_answer_link_for_question`;

  useEffect(() => {
    const fetchUrl = async () => {
      if (isGradable || !!shareableLink) return;
      try {
        await request.get(url).then(res => {
          setShareableLink(res.shareable_link);
        });
      } catch (error) {
        console.error(error);
      }
    };
    if (hasAnswerBeenSubmitted) fetchUrl();
  }, [url, isGradable, shareableLink, hasAnswerBeenSubmitted]);

  return (
    <>
      {hasAnswerBeenSubmitted && !isGradable && (
        <div className="d-f fd-c pt-24">
          <Text className="d-f ai-c" variant={TEXT_VARIANTS.TITLE_BOLD}>
            <Icon name="high_five_plain" className="is-32 mr-8" />
            {t('practice.practice_feedback.feedback_title')}{' '}
            {t('questions.question.peer_feedback.practice_completed')}
          </Text>
          <div className="mb-16">
            <Text variant={TEXT_VARIANTS.BODY}>
              {t('questions.question.peer_feedback.improving')}
            </Text>
          </div>
          <span className="d-f w-fill">
            <CopyLink
              link={shareableLink}
              className="fz-16 p-12 mh-36 minw-200 lh-20"
              copyText={t('common.copy')}
              useIcon={false}
            />
          </span>
        </div>
      )}
    </>
  );
};

export default props => <HighFiveShareableLink {...props} />;
